import { jsx as _jsx } from "react/jsx-runtime";
import App from "./App";
import { createRoot } from "react-dom/client";
import './App.css';
const root = createRoot(document.getElementById('root'));
root.render(_jsx(App, {}));
